// extracted by mini-css-extract-plugin
export default {"main":"yihzf","no-bottom-padding":"g1a54","content":"QatOX"};